export const AddEventType = {
  //onboarding
  WEBSITE_URL_IN_VIDEO_NOTE_PAGE: "Add WEBSITE URL in Video note page",

  // Note Mate
  ADD_CHAT_MESSAGE_IN_NOTE_MATE_CHAT: "Add CHAT MESSAGE in Note mate",
};
